import React, {useState} from 'react'
import useReCaptcha from "../../Providers/Captchaservice/useReCaptcha";
import { encryptUserId } from "../Common/cryptoUtils";

export const UserActivityLog = async ( activity) => {
    const token = localStorage.getItem("token");
    const encryptedactivity= encryptUserId(activity);
    const usaObj = {
        action: encryptedactivity,
        token: token
    };

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/UserActivityLog/useractivitylogsent`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(usaObj),
        });            
        const data = await response.json();
        if (data.success) {
            console.log('Activity logged successfully');
        } else {
            console.log('Error logging activity:', response);
        }
    } catch (error) {
        console.error('Error submitting form:', error);
    }
};


